{
  "users": {
    "edit": {
      "title": "Gebruiker aanpassen",
      "first_name": "Voornaam",
      "last_name": "Achternaam"
    }
  }
}
